
import { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { SharedSelect } from './SharedSelect';
import { InputField } from './InputField';
import { SharedButton } from './Button';
import { ExpiryCheck } from '../Static_Services/Staff_Services';
import { useEffect } from 'react';
import { buy_now_services_cash, cardGet, clover_buy_now_services, clover_buy_now_services_by_save_on_card_new, generateToken } from '../Studio-Services/Studio_Services';
import Swal from 'sweetalert2';
import logo from '../Images/logo_white_web.png'
import { useNavigate } from 'react-router-dom';
import { errorAlert } from '../Static_Services/Alertmsg';

export const SharedPayModal = ({ rowObject, upDate, setLoder, dCodeId = '', dCodeName = '' }) => {
  const [userDetail, setUserDetail] = useState();

  const [cardSaved, setCardSaved] = useState(false);
  const [clientCards, setClientCards] = useState([]);
  const [innerLoader, setInnerLoader] = useState(false);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('st_userData'))) {
      setUserDetail(JSON.parse(localStorage.getItem('st_userData')));
    }
  }, [])


  const [error, setError] = useState({ mode: "", transactionid: "", notes: "", });


  const paymodeOP = [
    { value: "Cash", label: "Cash" },
    { value: "POS", label: "POS" },
    { value: "Pass", label: "Pass" },
    { value: "GiftCard", label: "GiftCard" },
    { value: "Check", label: "Check" },
    { value: "Direct Debit", label: "Direct Debit" }
  ]
  const [paytype, setPaytype] = useState();
  const modeHandler = (e) => {
    const value = e.target.value;
    setError((pre) => ({
      ...pre,
      mode: "",
    }));
  }
  const errorHandler = (e) => {
    const { name, value } = e.target;
    setError((pre) => ({
      ...pre,
      [name]: "",
    }));
  };



  const submitHandler = async (e) => {
    e.preventDefault();
    let isValid = 1;
    const fData = new FormData(e.target);
    const fValue = Object.fromEntries(fData.entries());

    const mode = fValue.mode ? fValue.mode : "";
    const transactionid = fValue.transactionid ? fValue.transactionid : '12345';
    const notes = fValue.notes ? fValue.notes : "none";
    const tips = fValue.tip ? fValue.tip : "none";
    if (!mode) { setError((pre) => ({ ...pre, mode: "*Required" })); isValid = 2 }
    if (!transactionid) { setError((pre) => ({ ...pre, transactionid: "*Required" })); isValid = 2 }
    if (!notes) { setError((pre) => ({ ...pre, notes: "*Required" })); isValid = 2 }
    if (isValid === 1) {
      setLoder(true);
      const tempObj = {};
      tempObj.payment_transaction_id = transactionid;
      tempObj.comment = notes;
      tempObj.service_id = rowObject.service_id;
      tempObj.transaction_id = rowObject.transaction_id;

      tempObj.amount = rowObject.totalFee;
      tempObj.tax1Amt = rowObject.tax1Amt;
      tempObj.tax2Amt = rowObject.tax2Amt;
      tempObj.tip_comment = rowObject.tipAmt;
      tempObj.discount = rowObject.discount;
      tempObj.subtotal = rowObject.subtotal;
      tempObj.payment_mode = mode;

      tempObj.dCodeId = dCodeId;
      tempObj.dCodeName = dCodeName;

      const resp = await buy_now_services_cash(tempObj);
      if (resp) {
        setLoder(false);
        let myObjet = { ...rowObject };
        e.target.reset();
        myObjet.booking_status = 'Success';
        upDate(myObjet, false);
        Swal.fire({
          html: `
        <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
        <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
        <p class="text-center my-4 textcolor">
          <small class="textWhite">${resp.data.message}</small>
        </p>
      `,
          showClass: {
            popup: 'custom-dialog-container',
          },
          customClass: {
            confirmButton: 'custom-button custom-button-size modalbtn',
          },
          confirmButtonText: 'Continue',
        })
      }
    }
  }

  const [expiryDate, setExpiryDate] = useState();
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    if (e.nativeEvent.inputType === "deleteContentBackward") {
      if (inputValue.endsWith('/')) {
        setExpiryDate(inputValue.slice(0, -1));
      } else { setExpiryDate(inputValue); }
    } else {
      if (inputValue.length === 2 && inputValue.charAt(2) !== '/') {
        setExpiryDate(inputValue + '/');
      } else if (inputValue.length === 8) { return; } else { setExpiryDate(inputValue); }
    }
  };

  const [carderror, setCarderror] = useState({ name: "", crnumber: "", dates: "", cvv: "", tip: '' });
  const [cardData, setCardData] = useState({ name: "", crnumber: "", dates: "", cvv: "", tip: '' });

  const CardInputChange = (e) => {
    const { name, value } = e.target;
    const cleanedValue = value.replace(/^\s+/g, '');
    setCardData((pre) => ({ ...pre, [name]: cleanedValue }));
    setCarderror((pre) => ({ ...pre, [name]: "" }));
  }

  const payBycard = async (e) => {
    e.preventDefault();
    let isValid = 1;
    let expiry_month = '';
    let expiry_year = '';
    let expired = '';

    if (expiryDate) {
      expired = ExpiryCheck(expiryDate);
    }
    if (expired) {
      expiry_month = expired[0];
      expiry_year = expired[1];
    } else {
      setCarderror((pre) => ({ ...pre, dates: "* Valid Till is required" }));
      isValid = 2;
    }

    if (!cardData.name) { setCarderror((pre) => ({ ...pre, name: "* Card Holder Name is required" })); isValid = 3; };
    if (!cardData.crnumber) {
      setCarderror((pre) => ({ ...pre, crnumber: "* Card Number is required" }))
      isValid = 4;
    };
    if (!cardData.cvv) {
      setCarderror((pre) => ({ ...pre, cvv: "* CVV is required" }));
      isValid = 5;
    };
    if (isValid === 1) {

      if (rowObject.totalFee == 0) {
        setLoder(true);
        const tempObj = {};
        tempObj.payment_transaction_id = '12345';
        tempObj.comment = 'Full Amount Discount';
        tempObj.service_id = rowObject.service_id;
        tempObj.transaction_id = rowObject.transaction_id;

        tempObj.amount = rowObject.totalFee;
        tempObj.tax1Amt = rowObject.tax1Amt;
        tempObj.tax2Amt = rowObject.tax2Amt;
        tempObj.tip_comment = rowObject.tipAmt;
        tempObj.discount = rowObject.discount;
        tempObj.subtotal = rowObject.subtotal;
        tempObj.payment_mode = 'VISA';

        tempObj.dCodeId = dCodeId;
        tempObj.dCodeName = dCodeName;

        const resp = await buy_now_services_cash(tempObj);
        if (resp) {
          setLoder(false);
          let myObjet = { ...rowObject };
          e.target.reset();
          myObjet.booking_status = 'Success';
          upDate(myObjet, false);
          Swal.fire({
            html: `
        <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
        <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
        <p class="text-center my-4 textcolor">
          <small class="textWhite">${resp.data.message}</small>
        </p>
      `,
            showClass: {
              popup: 'custom-dialog-container',
            },
            customClass: {
              confirmButton: 'custom-button custom-button-size modalbtn',
            },
            confirmButtonText: 'Continue',
          })
        }
      } else {

        setLoder(true);
        let paymentData = {
          "card_name": cardData.name,
          "number": cardData.crnumber,
          "expiry_month": expiry_month,
          "expiry_year": expiry_year,
          "cvd": cardData.cvv,
          "business_id": userDetail.business_id,
          "country_code": '',
        }

        const resp = await generateToken(paymentData);
        if (resp) {

          const tempObj = {};
          tempObj.service_id = rowObject.service_id;
          tempObj.transaction_id = rowObject.transaction_id;
          tempObj.user_id = rowObject.user_id;
          tempObj.savecard = cardSaved ? 1 : 0;
          tempObj.card_id = "";
          tempObj.token = resp.data.data.token;
          tempObj.business_id = userDetail.business_id;
          tempObj.country_code = '';


          tempObj.amount = rowObject.totalFee;
          tempObj.tax1Amt = rowObject.tax1Amt;
          tempObj.tax2Amt = rowObject.tax2Amt;
          tempObj.tip_comment = rowObject.tipAmt;
          tempObj.discount = rowObject.discount;
          tempObj.subtotal = rowObject.subtotal;

          tempObj.customer_name = cardData.name;
          tempObj.number = cardData.crnumber;
          tempObj.expiry_month = expiry_month;
          tempObj.expiry_year = expiry_year;
          tempObj.cvd = cardData.cvv;

          tempObj.dCodeId = dCodeId;
          tempObj.dCodeName = dCodeName;


          const responce = await clover_buy_now_services(tempObj);
          if (responce) {
            setLoder(false);
            let myObjet = rowObject;
            e.target.reset();
            myObjet.booking_status = 'Success';
            upDate(myObjet, false);

            Swal.fire({
              html: `
          <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
          <p class="text-center my-4 textcolor">
            <small class="textWhite">${responce.data.message}</small>
          </p>
        `,
              showClass: {
                popup: 'custom-dialog-container',
              },
              customClass: {
                confirmButton: 'custom-button custom-button-size modalbtn',
              },
              confirmButtonText: 'Continue',
            })
          } else setLoder(false);
        } else setLoder(false);
      }
    }
    setLoder(false);
  }


  const checkCardHandler = (e) => {
    const { checked } = e.target;
    Swal.fire({
      text: "Confirm with the client that they agree to have their card saved on file ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: 'NO'
    }).then((result) => {
      if (result.isConfirmed) {
        setCardSaved(true);
      } else {
        setCardSaved(false);
      }
    });
  }



  const [savedCardId, setSavedCardId] = useState({ 'cardId': '', 'isChecked': false });
  const handleRadioChange = (event) => {
    const { value } = event.target;
    let pre = { ...savedCardId };
    if (pre.isChecked) {
      pre.isChecked = false;
      pre.cardId = '';
    } else {
      pre.isChecked = true;
      pre.cardId = value;
    }
    setSavedCardId(pre);
  };


  const paymentViaSaveCard = async (card) => {
    if (!card?.card_token) { errorAlert("Something went wrong"); return; }

    const payload = {};
    payload.service_id = rowObject.service_id;
    payload.transaction_id = rowObject.transaction_id;
    payload.user_id = rowObject.user_id;
    payload.savecard = 0;

    payload.business_id = userDetail.business_id;
    payload.country_code = '';

    payload.token = card.card_token;
    payload.card_id = card.card_id;

    payload.amount = rowObject.totalFee;
    payload.tax1Amt = rowObject.tax1Amt;
    payload.tax2Amt = rowObject.tax2Amt;
    payload.tip_comment = rowObject.tipAmt;
    payload.discount = rowObject.discount;
    payload.subtotal = rowObject.subtotal;

    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Pay"
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (rowObject.totalFee == 0) {
          setLoder(true);
          const tempObj = {};
          tempObj.payment_transaction_id = '12345';
          tempObj.comment = 'Full Amount Discount';
          tempObj.service_id = rowObject.service_id;
          tempObj.transaction_id = rowObject.transaction_id;

          tempObj.amount = rowObject.totalFee;
          tempObj.tax1Amt = rowObject.tax1Amt;
          tempObj.tax2Amt = rowObject.tax2Amt;
          tempObj.tip_comment = rowObject.tipAmt;
          tempObj.discount = rowObject.discount;
          tempObj.subtotal = rowObject.subtotal;
          tempObj.payment_mode = 'VISA';

          const resp = await buy_now_services_cash(tempObj);
          if (resp) {
            setLoder(false);
            let myObjet = { ...rowObject };
            myObjet.booking_status = 'Success';
            upDate(myObjet, false);
            Swal.fire({
              html: `
          <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
          <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
          <p class="text-center my-4 textcolor">
            <small class="textWhite">${resp.data.message}</small>
          </p>
        `,
              showClass: {
                popup: 'custom-dialog-container',
              },
              customClass: {
                confirmButton: 'custom-button custom-button-size modalbtn',
              },
              confirmButtonText: 'Continue',
            })
          }
        } else {

          setLoder(true);
          const response = await clover_buy_now_services(payload);
          if (response) {
            setLoder(false);
            let myObjet = rowObject;
            myObjet.booking_status = 'Success';
            upDate(myObjet, false);
            Swal.fire({
              html: `
                <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                <h4 class="title text-capitalize text-center mt-4 textWhite">Success</h4>
                <p class="text-center my-4 textcolor">
                  <small class="textWhite">${response.data.message}</small>
                </p>
              `,
              showClass: {
                popup: 'custom-dialog-container',
              },
              customClass: {
                confirmButton: 'custom-button custom-button-size modalbtn',
              },
              confirmButtonText: 'Continue',
            })
          } else setLoder(false);
        }
      } else setLoder(false);
    });
    setLoder(false);
  }


  const getClientCards = async (id) => {
    setInnerLoader(true);
    const payload = { "userid": id, }
    const resp = await cardGet(payload);
    if (resp) {
      setInnerLoader(false);
      setClientCards(resp.data.data);
    }
    setInnerLoader(false);
  }

  useEffect(() => {
    if (rowObject?.user_id) {
      const id = rowObject?.user_id;
      getClientCards(id);
    }
  }, [rowObject])

  return (
    <>
      <Row className='mt-4 mb-4'>
        {innerLoader && <div class="spinner-border mt-5" role="status"></div>}
        <h4>Credit card / Debit card</h4>
        <Col md={12}>
          <p>Payment Mode</p>
          <Row style={{ justifyContent: "center" }}>
            <Col md={3}>
              <button type='button' onClick={() => setPaytype(3)} className={paytype === 3 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Card On File</button>
            </Col>
            <Col md={3}>
              <button type='button' onClick={() => setPaytype(1)} className={paytype === 1 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Other</button>
            </Col>
            <Col md={3}>
              <button type='button' onClick={() => setPaytype(2)} className={paytype === 2 ? 'ownCartBtn ownCardBtnActive' : 'ownCartBtn'}>Card</button>
            </Col>
          </Row>
        </Col>
        <Row className='mt-5' style={{ justifyContent: "center" }}>

          {paytype === 1 &&
            <>
              <Form autoComplete='off' onSubmit={submitHandler}>
                <Row>
                  <Col>
                    <SharedSelect
                      name={"mode"}
                      lable={"Payment Mode"}
                      error={error.mode}
                      onChange={modeHandler}
                      options={paymodeOP}
                    />
                  </Col>
                  <Col>
                    <InputField
                      type={"text"}
                      name={"transactionid"}
                      error={error.transactionid}
                      lable={"Transaction ID"}
                      onChange={errorHandler}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputField
                      type={"text"}
                      name={"notes"}
                      error={error.notes}
                      lable={"Notes"}
                      onChange={errorHandler}
                    />
                  </Col>
                  {/* <Col>
                       <div className="form-group">
                       <label className="form-label inputLable">Tip </label>
                      <input
                        type="number"
                        className="form-control"
                        autoComplete="off"
                        name='tip'
                        value={cardData.tip}
                        onChange={CardInputChange}
                      />
                      </div>
                  </Col> */}
                </Row>
                <Row className='mt-3'>
                  <Col>
                    <SharedButton
                      className={"w-100"}
                      type={"submit"}
                      title={"Proceed To Pay"}
                      variant={"primary"}
                    />
                  </Col>
                  <Col></Col>
                </Row>
              </Form>
            </>
          }
          {paytype === 2 && // Pay By Card
            <>
              <Form autoComplete='off' onSubmit={payBycard}>
                <Row md={12} className='m-0 p-0'>
                  <Col md={12} className='mb-3' style={{ justifyContent: 'space-between', display: 'flex', padding: '20px 30px 15px 30px', background: '#f2f2f2', border: "1px solid #f2f2f2", borderRadius: "10px" }} >
                    <div>
                      <h5>Debit/credit card details :</h5>
                    </div>
                    {rowObject.totalFee != 0 &&
                      <div className='d-flex'>
                        <h5>Save Card : </h5>
                        <span style={{ paddingLeft: '10px', cursor: 'pointer' }}>
                          <input type="checkbox" name="saveCard" className="ownCheck" onChange={checkCardHandler} checked={cardSaved} style={{ cursor: 'pointer' }} />
                        </span>
                      </div>
                    }
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <p className="brand-color3 text-left font-14 mb-2"> Name On Card </p>
                      <input
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        name='name'
                        placeholder="Sophie Joe"
                        value={cardData.name}
                        onChange={CardInputChange}
                      />
                      <small className="text-danger">{carderror.name}</small>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group client-buy-input-cardno">
                      <p className="brand-color3 text-left font-14 mb-2"> Card Number </p>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        placeholder="4121 4411 3131 8554"
                        name='crnumber'
                        value={cardData.crnumber}
                        onChange={CardInputChange}
                        maxLength={19}
                      />
                      <small className="text-danger">{carderror.crnumber}</small>
                    </div>
                  </Col>
                </Row>
                <Row md={12} className='m-0 p-0'>
                  <Col md={6}>
                    <div className="form-group">
                      <p className="brand-color3 text-left font-14 mb-2"> Valid Till </p>
                      <input
                        type="text"
                        name={'dates'}
                        className="form-control"
                        placeholder="MM/YYYY"
                        value={expiryDate}
                        onChange={handleInputChange}
                        pattern="^[0-9]{2}/[0-9]{4}"
                        autoComplete="new-password"
                        lable={"Valid Through"}
                      />
                      <small className="text-danger">{carderror.dates}</small>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group">
                      <p className="brand-color3 text-left font-14 mb-2"> CVV </p>
                      <input
                        type="password"
                        autoComplete="off"
                        className="form-control"
                        placeholder="eg. 201"
                        name='cvv'
                        value={cardData.cvv}
                        onChange={CardInputChange}
                        maxLength={3}
                      />
                      <small className="text-danger">{carderror.cvv}</small>
                    </div>
                  </Col>
                </Row>
                <Row className='mt-3'>
                  <Col>
                    <SharedButton
                      className={"w-100"}
                      type={"submit"}
                      title={"Proceed To Pay"}
                      variant={"primary"}
                    />
                  </Col>
                  <Col></Col>
                </Row>
              </Form>
            </>
          }

          {paytype === 3 ?
            <Col md={12}>
              <Row >
                <div className="card-details" >
                  <h5 className="payment-head font-arialrouded text-capitalize pb-2">Saved Cards</h5>
                  <div>
                    {clientCards && clientCards.length > 0 ?
                      <div className="row m-0 p-0">
                        {clientCards.map((cardsave) => (
                          <div className='col-md-4 p-2  mb-3'>
                            <div className="row mx-0 payment-history-box white-bg border-radius6 box-shadow1 p-3 ">
                              <div className="col-2 pl-0">
                                {(cardsave.card_type == 'VISA' || cardsave.card_type == 'visa') && <img src="assets/images/visa_card.png" className="img-fluid" />}
                                {cardsave.card_type == 'MC' && <img src="assets/images/master_card.png" className="img-fluid" />}
                                {cardsave.card_type == 'AM' && <img src="assets/images/american_express.png" className="img-fluid" />}
                              </div>
                              <div className="col-8">
                                <p className="mb-0 font-14 font-w-500 dark-color"> {cardsave.number} </p>
                                <h5 className="mb-0 font-12 dark-color mt-2">Valid Till(MM/YY) </h5>
                                <p className="mb-0 font-12 dark-color"> {cardsave.expiry_month}  /
                                  {cardsave.expiry_year} </p>
                              </div>
                              <div className="col-2 text-right">
                                <input
                                  style={{ background: savedCardId?.cardId === cardsave.card_id ? '#0075ff' : '', borderRadius: '10px' }}
                                  type="radio"
                                  name="pass_radio"
                                  id={cardsave.card_id}
                                  className="pass_input_checkbox form-control"
                                  value={cardsave.card_id}
                                  checked={savedCardId?.cardId === cardsave.card_id && savedCardId.isChecked}
                                  onClick={handleRadioChange}
                                />
                              </div>
                              {savedCardId?.cardId == cardsave.card_id ?
                                <form autoComplete="off">
                                  <div className="text-center d-flex flex-wrap mt-4" style={{
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                  }}>
                                    <button class="btn btn-brandbluegrad d-block w-50" type="button"
                                      onClick={() => paymentViaSaveCard(cardsave)}
                                    >Submit</button >
                                  </div >
                                </form >
                                : ''}
                            </div >
                          </div>
                        ))}
                      </div >
                      :
                      !innerLoader &&
                      <p class="text-center"> No Record Found</p >
                    }
                  </div >
                </div >
              </Row >
            </Col>
            : ""}
        </Row>
      </Row>
    </>
  )
}
